<template>
	<div>
		<div style="color: #3e3e3e;
				font-size: 18px;margin-bottom: 15px;">系统设置-{{activeName=="first"?"权限设置":""}}{{activeName=="second"?"员工管理":""}}</div>
		 <el-tabs v-model="activeName" type="card">
		    <el-tab-pane label="权限设置" name="first">
				<first></first>
			</el-tab-pane>
		    <el-tab-pane label="员工管理" name="second">
				<second></second>
			</el-tab-pane>
		  </el-tabs>
	</div>
</template>

<script>
import first from "./jurisdiction/jurisdiction1.vue"
import second from "./jurisdiction/jurisdiction2.vue"
	export default {
		components:{
			first,second
		},
		data() {
			return {
              activeName: 'first'
			};
		},
		methods: {
		
		}
	};
</script>

<style lang="less" scoped>

</style>
